export const DEFAULT_ADDRESS_SCREEN_TITLE = "Confirm address";
export const DEFAULT_ADDRESS_SCREEN_SUBTITLE =
  "Make sure the information below is correct.";
export const DEFAULT_RETURNING_ITEMS_FROM_TITLE = "Returning items from:";
export const DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE = "Shipping new items to:";
export const DEFAULT_YOUR_ADDRESS_TITLE = "Your address:";
export const DEFAULT_SAME_AS_RETURNING_ITEMS_FROM_TEXT =
  "Same as returning items from.";
export const DEFAULT_EDIT_ADDRESS_TITLE = "Edit address";

export function getDefaultAddressSectionTitle({
  hasNonGreenReturnItems,
  showNewItems,
}: {
  hasNonGreenReturnItems: boolean;
  showNewItems: boolean;
}) {
  if (hasNonGreenReturnItems) {
    return DEFAULT_RETURNING_ITEMS_FROM_TITLE;
  }
  if (showNewItems) {
    return DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE;
  }
  return DEFAULT_YOUR_ADDRESS_TITLE;
}
